import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/error/unauthorised',
            name: 'unauthorised-error',
            component: () => import(/* webpackChunkName: "err" */ './views/errors/Unauthorised.vue'),
        },
        {
            path: '/error/azure',
            name: 'azure-error',
            component: () => import(/* webpackChunkName: "err" */ './views/errors/AzureError.vue'),
        },
        {
            path: '/error/edl',
            name: 'edl-error',
            component: () => import(/* webpackChunkName: "err" */ './views/errors/EDLError.vue'),
        },

        {
            path: '/login',
            name: 'login-azure',
            component: () => import(/* webpackChunkName: "log" */ './views/logins/LoginAzure.vue'),
        },
        {
            path: '/login/pin',
            name: 'login-pin',
            component: () => import(/* webpackChunkName: "log" */ './views/logins/LoginUsernamePIN.vue'),
        },
        {
            path: '/student/:studentId',
            name: 'admin-access',
            component: () => import(/* webpackChunkName: "log" */ './views/logins/AdminAccess.vue'),
        },

        {
            path: '/course/:courseCode/information',
            name: 'course-course-information',
            component: () => import(/* webpackChunkName: "inf" */ './views/CourseInformation.vue'),
        },
        {
            path: '/course/:courseCode/timetable',
            name: 'course-course-timetable',
            component: () => import(/* webpackChunkName: "inf" */ './views/CourseTimetable.vue'),
        },
        {
            path: '/course/:courseCode/induction',
            name: 'course-course-induction',
            component: () => import(/* webpackChunkName: "inf" */ './views/CourseInduction.vue'),
        },

        {
            path: '/photo-guidance',
            name: 'photo-guidance',
            component: () => import(/* webpackChunkName: "inf" */ './views/PhotoGuidance.vue'),
        },
        {
            path: '/here-to-help',
            name: 'here-to-help',
            component: () => import(/* webpackChunkName: "inf" */ './views/HereToHelp.vue'),
        },
        {
            path: '/societies',
            name: 'societies',
            component: () => import(/* webpackChunkName: "inf" */ './views/Societies.vue'),
        },
        {
            path: '/campus-guides',
            name: 'campus-guides',
            component: () => import(/* webpackChunkName: "inf" */ './views/CampusGuides.vue'),
        },
        {
            path: '/free-bus-travel',
            name: 'free-bus-travel',
            component: () => import(/* webpackChunkName: "inf" */ './views/FreeBusTravel.vue'),
        },

        {
            path: '/redirect/student-portal',
            name: 'redirect-student-portal',
            component: () => import(/* webpackChunkName: "rdr" */ './views/StudentPortalRedirect.vue'),
        },

        // Standard Enrolment Registration
        {
            path: '/enrolment/:enrolmentID/2022',
            name: 'enrolment-2022-home',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/PersonalDetails.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/personal-details',
            name: 'enrolment-2022-personal-details',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/PersonalDetails.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/nationality',
            name: 'enrolment-2022-nationality',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/Nationality.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/address',
            name: 'enrolment-2022-address',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/Address.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/term-time-address',
            name: 'enrolment-2022-term-time-address',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/TermTimeAddress.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/contact-information',
            name: 'enrolment-2022-contact-information',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/ContactInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/emergency-contact',
            name: 'enrolment-2022-emergency-contact',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/EmergencyContact.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/fee-payment-method',
            name: 'enrolment-2022-fee-payment-method',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/FeePaymentMethod.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/employment-information',
            name: 'enrolment-2022-employment-information',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/EmploymentInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/previous-education',
            name: 'enrolment-2022-previous-education',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/PreviousEducation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/care-information',
            name: 'enrolment-2022-care-information',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/CareInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/protected-characteristics',
            name: 'enrolment-2022-protected-characteristics',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/ProtectedCharacteristics.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/disability-information',
            name: 'enrolment-2022-disability-information',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/DisabilityInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/vehicle-information',
            name: 'enrolment-2022-vehicle-information',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/VehicleInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/graduation-consent',
            name: 'enrolment-2022-graduation-consent',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/GraduationConsent.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/course-marketing-consent',
            name: 'enrolment-2022-course-marketing-consent',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/CourseMarketingConsent.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/summary',
            name: 'enrolment-2022-summary',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/Summary.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/confirmation',
            name: 'enrolment-2022-confirmation',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2022/standard/Confirmation.vue'),
        },

        // Short Enrolment Registration
        {
            path: '/enrolment/:enrolmentID/2022/short',
            name: 'short-enrolment-2022-home',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2022/short/PersonalDetails.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/short/personal-details',
            name: 'short-enrolment-2022-personal-details',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2022/short/PersonalDetails.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/short/address',
            name: 'short-enrolment-2022-address',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2022/short/Address.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/short/emergency-contact',
            name: 'short-enrolment-2022-emergency-contact',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2022/short/EmergencyContact.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/short/employer-information',
            name: 'short-enrolment-2022-employer-information',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2022/short/EmployerInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/short/care-information',
            name: 'short-enrolment-2022-care-information',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2022/short/CareInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/short/protected-characteristics',
            name: 'short-enrolment-2022-protected-characteristics',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2022/short/ProtectedCharacteristics.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/short/disability-information',
            name: 'short-enrolment-2022-disability-information',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2022/short/DisabilityInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/short/course-marketing-consent',
            name: 'short-enrolment-2022-course-marketing-consent',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2022/short/CourseMarketingConsent.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/short/summary',
            name: 'short-enrolment-2022-summary',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2022/short/Summary.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2022/short/confirmation',
            name: 'short-enrolment-2022-confirmation',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2022/short/Confirmation.vue'),
        },

        // Standard Enrolment Registration
        {
            path: '/enrolment/:enrolmentID/2023',
            name: 'enrolment-2023-home',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/PersonalDetails.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/personal-details',
            name: 'enrolment-2023-personal-details',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/PersonalDetails.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/nationality',
            name: 'enrolment-2023-nationality',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/Nationality.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/address',
            name: 'enrolment-2023-address',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/Address.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/term-time-address',
            name: 'enrolment-2023-term-time-address',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/TermTimeAddress.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/contact-information',
            name: 'enrolment-2023-contact-information',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/ContactInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/emergency-contact',
            name: 'enrolment-2023-emergency-contact',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/EmergencyContact.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/fee-payment-method',
            name: 'enrolment-2023-fee-payment-method',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/FeePaymentMethod.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/employment-information',
            name: 'enrolment-2023-employment-information',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/EmploymentInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/previous-education',
            name: 'enrolment-2023-previous-education',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/PreviousEducation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/care-information',
            name: 'enrolment-2023-care-information',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/CareInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/protected-characteristics',
            name: 'enrolment-2023-protected-characteristics',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/ProtectedCharacteristics.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/disability-information',
            name: 'enrolment-2023-disability-information',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/DisabilityInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/vehicle-information',
            name: 'enrolment-2023-vehicle-information',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/VehicleInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/graduation-consent',
            name: 'enrolment-2023-graduation-consent',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/GraduationConsent.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/course-marketing-consent',
            name: 'enrolment-2023-course-marketing-consent',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/CourseMarketingConsent.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/summary',
            name: 'enrolment-2023-summary',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/Summary.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/confirmation',
            name: 'enrolment-2023-confirmation',
            component: () => import(/* webpackChunkName: "reg" */ './views/enrolmentRegistration/2023/standard/Confirmation.vue'),
        },

        // Short Enrolment Registration
        {
            path: '/enrolment/:enrolmentID/2023/short',
            name: 'short-enrolment-2023-home',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2023/short/PersonalDetails.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/short/personal-details',
            name: 'short-enrolment-2023-personal-details',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2023/short/PersonalDetails.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/short/address',
            name: 'short-enrolment-2023-address',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2023/short/Address.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/short/emergency-contact',
            name: 'short-enrolment-2023-emergency-contact',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2023/short/EmergencyContact.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/short/employer-information',
            name: 'short-enrolment-2023-employer-information',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2023/short/EmployerInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/short/care-information',
            name: 'short-enrolment-2023-care-information',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2023/short/CareInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/short/protected-characteristics',
            name: 'short-enrolment-2023-protected-characteristics',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2023/short/ProtectedCharacteristics.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/short/disability-information',
            name: 'short-enrolment-2023-disability-information',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2023/short/DisabilityInformation.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/short/course-marketing-consent',
            name: 'short-enrolment-2023-course-marketing-consent',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2023/short/CourseMarketingConsent.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/short/summary',
            name: 'short-enrolment-2023-summary',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2023/short/Summary.vue'),
        },
        {
            path: '/enrolment/:enrolmentID/2023/short/confirmation',
            name: 'short-enrolment-2023-confirmation',
            component: () => import(/* webpackChunkName: "srg" */ './views/enrolmentRegistration/2023/short/Confirmation.vue'),
        },
    ],
});
